import { Backdrop, Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, TextField } from '@mui/material';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import axios2 from 'axios';
import { DeviceUUID } from 'device-uuid';
import { Base64 } from 'js-base64';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import {  setIpAddress, setSessionToken, setUserSession, setUserSessionFromLocale } from 'src/utils/Common';
import validate from 'validate.js';
import { text } from "../../modules/languages/index";


const schema = {
  email: {
    presence: { allowEmpty: false, message: 'zorunlu alan' },
    email: true
  },
  password: {
    presence: { allowEmpty: false, message: 'zorunlu alan' }
  }
};

const styles = {
  root: {},
  NoZoomField: {
    fontSize: '16px',

  },
  fields: (theme) => ({
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  }),
  submitButton: (theme) => ({
    marginTop: theme.spacing(2),
    width: '100%'
  }),
  backdrop: (theme) => ({
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  }),
};

function LoginForm({ className, ...rest }) {

  const [Loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [IPAdres, setIPAdres] = useState('');
  const publicIp = require('public-ip');
  const [open, setOpen] = React.useState(false);
  const [DeviceId, setDeviceId] = React.useState("");




  React.useEffect(() => {
    const redirect = setUserSessionFromLocale();
    if (redirect) {
      navigate('/profile/1/timeline');
    }
    (async () => {
      setIPAdres(await publicIp.v4());
    })();
    var uuid = new DeviceUUID().get();
    setDeviceId(uuid);
    // eslint-disable-next-line
  }, [])

  const [formState, setFormState] = useState({
    isValid: false,
    values: {},
    touched: {},
    errors: {}
  });

  const [error, setError] = useState(null);

  const handleChange = (event) => {
    event.persist();
    setFormState((prevFormState) => ({
      ...prevFormState,
      values: {
        ...prevFormState.values,
        [event.target.name]:
          event.target.type === 'checkbox'
            ? event.target.checked
            : event.target.value
      },
      touched: {
        ...prevFormState.touched,
        [event.target.name]: true
      }
    }));
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter"){
      handleLogin();
    }
  };

  
  const SaveLocal = async (UserId, AuthToken, ServiceShopCode, ServiceShopId, TechnicianId) => {
    //SaveLocalInvoiceAddress(UserId, AuthToken, ServiceShopCode, ServiceShopId, TechnicianId);
  };

  

  const handleLogin = async (event) => {
    setError(null);
    setLoading(true);
    const dataUser = [{
      UserName: Base64.encode(formState.values.UserName),
      TerminalId: DeviceId || 1,
      VersionNr: process.env.REACT_APP_VERSION,
      TerminalIp: IPAdres || 1,
      LanguageId: 1,
      Password: Base64.encode(formState.values.password)
    }];
    const configUser = {
      headers: {
        'Content-Type': 'application/json'
        , 'IpAddress': IPAdres
      }
    };
    let Address = process.env.REACT_APP_API_URL + "/GetUserAuthorization";
    axios2.post(Address, dataUser, configUser)
      .then((response) => {
        if (response.data[0].SessionToken === undefined) {
          setError("Kullanıcı Adı ve Parolanızı kontrol ediniz!...");
          setLoading(false);
        } else {
          setSessionToken(response.data[0].SessionToken, response.data[0].SessionTokenWs || '');
          setIpAddress(IPAdres);
          setUserSession(response.data[0].SessionToken, response.data[0].SessionTokenWs || '', response.data[0]);
          setLoading(false);
          SaveLocal(response.data[0].UserId, response.data[0].SessionToken,
            response.data[0].ServiceShopCode, response.data[0].ServiceShopId,
            response.data[0].TechnicianId);
          setLoading(false);
          navigate('/profile/1/timeline');
        }
      }).catch((error) => {
        setError("Kullanıcı Adı ve Parolanızı kontrol ediniz!...");
        setLoading(false);
      });
  };


  

  const hasError = (field) => (!!(formState.touched[field] && formState.errors[field]));

  useEffect(() => {
    const errors = validate(formState.values, schema);

    setFormState((prevFormState) => ({
      ...prevFormState,
      isValid: !errors,
      errors: errors || {}
    }));
  }, [formState.values]);

  const handleClose = () => {
    setOpen(false);
  };

  const meta = document.createElement('meta');
  meta.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
  meta.setAttribute('name', 'viewport');
  document.head.appendChild(meta);
  return (
    <form
      {...rest}
      className={className}
      style={styles.root}
    >
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">{"Bilgilendirme"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {/* {Uyari} */}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Tamam
          </Button>
        </DialogActions>
      </Dialog>
      {
        Loading ?
          <Backdrop sx={styles.backdrop} open={Loading}>
            <CircularProgress color="inherit" />
          </Backdrop>
          : <div></div>
      }
      <Box sx={styles.fields}>
        <TextField
          fullWidth
          style={styles.NoZoomField}
          label={text("Kullanıcı_Adı")}
          name="UserName"
          onChange={handleChange}
          onKeyDown={handleKeyDown}
          value={formState.values.UserName || ''}
          variant="outlined"
        />
        <TextField
          error={hasError('password')}
          fullWidth
          helperText={
            hasError('password') ? formState.errors.password[0] : null
          }
          label={text("Parola")}
          name="password"
          onChange={handleChange}
          type="password"
          onKeyDown={handleKeyDown}
          value={formState.values.password || ''}
          variant="outlined"
        />
      </Box>
      {error && <><small style={{ color: 'red' }}>{error}</small><br /></>}<br />
      <Button
        sx={styles.submitButton}
        color="secondary"
        size="large"
        variant="contained"
        endIcon={<LockOpenIcon>Kaydet</LockOpenIcon>}
        onClick={handleLogin}
      >
        {text("Giris")}
      </Button>
    </form>
  );
}

LoginForm.propTypes = {
  className: PropTypes.string
};

export default LoginForm;
